export default __webpack_public_path__ + "static/media/SKILL.8324be73.svg";